// src/Utils/creatureXpCurve.ts

export function creatureXpNeededForNextLevel(level: number): number {
  const L = Math.max(1, Number(level) || 1);
  return Math.max(100, L * 100); // level 1->100, level 2->200, level 3->300...
}

export function creatureProgressFromTotalXp(totalXp: number) {
  let xp = Math.max(0, Number(totalXp) || 0);
  let level = 1;

  while (xp >= creatureXpNeededForNextLevel(level)) {
    xp -= creatureXpNeededForNextLevel(level);
    level += 1;
  }

  const neededForNext = creatureXpNeededForNextLevel(level);

  return {
    level,
    currentInLevel: xp,
    neededForNext,
    pct: neededForNext > 0 ? (xp / neededForNext) * 100 : 0,
  };
}
